export function checkMXBNNumber(gstNumber){
    //ABC-123456-12A(P&G851223B24) or ABCD-123456-12A
    var regex = /^[^0-9]{3,4}(-?)[0-9]{6}(-?)[A-Za-z0-9]{3}$/;

    // Remove all spaces
    gstNumber = gstNumber.replace(/\s/g, '');
    return regex.test(gstNumber);
}

export function checkKRBNNumber(gstNumber) {
    var regex = /^\d{10}$/;

    // Remove all spaces
    gstNumber = gstNumber.replace(/\s/g, '').replace(/-/g, '');
    return regex.test(gstNumber);
}

export function checkIDBNNumber(gstNumber) {
    var regex = /^[A-Za-z0-9]{15}$/;

    // Remove all spaces
    gstNumber = gstNumber.replace(/\s/g, '').replace(/-/g, '');
    return regex.test(gstNumber);
}

export function checkSABNNumber(gstNumber) {
    // Remove all spaces
    gstNumber = gstNumber.replace(/\s/g, '').replace(/-/g, '');
    return gstNumber.length !== 0 && gstNumber.length <= 20;
}

export function checkSGBNNumber(gstNumber){
    var regex = /^[A-Za-z0-9]{10}$/;

    // Remove all spaces and '-'
    gstNumber = gstNumber.replace(/\s/g, '');
    return regex.test(gstNumber);
}

export function checkZABNNumber(gstNumber) {
    var regex = /^[4]\d{9}$/;

    // Remove all spaces
    gstNumber = gstNumber.replace(/\s/g, '').replace(/-/g, '');
    return regex.test(gstNumber);
}

export function checkAEBNNumber(gstNumber) {
    var regex = /^\d{15}$/;

    // Remove all spaces
    gstNumber = gstNumber.replace(/\s/g, '').replace(/-/g, '');
    return regex.test(gstNumber);
}

/**
 * Validate ABN
 * @param {string} abn
 * @return {boolean} is ABN number valid
 *
 * 0. ABN must be 11 digits long
 * 1. Subtract 1 from the first (left) digit to give a new eleven digit number
 * 2. Multiply each of the digits in this new number by its weighting factor
 * 3. Sum the resulting 11 products
 * 4. Divide the total by 89, noting the remainder
 * 5. If the remainder is zero the number is valid
 */
export function checkABNNumber(abn){
    var isValid = true;

    // Remove all spaces
    abn = abn.replace(/\s/g, '');

    // 0. ABN must be 11 digits long
    isValid &= abn && /^\d{11}$/.test(abn);

    if(isValid){
        var weightedSum = 0;
        var weight = [10, 1, 3, 5, 7, 9, 11, 13, 15, 17, 19];

        // Rules: 1, 2, 3
        for (var i = 0; i < weight.length; i++) {
            weightedSum += (parseInt(abn[i]) - ((i === 0) ? 1 : 0)) * weight[i];
        }

        // Rules: 4, 5
        isValid &= ((weightedSum % 89) === 0);
    }

    return isValid;
}

export function checkINTaxData(data) {
    const validationMap = [
        {
            condition: data?.tin_exists_online !== true,
            code: 'tin_not_exists_online'
        },
        {
            condition: data?.taxpayer?.error_code === 'state_mismatch',
            code: 'state_mismatch'
        }
    ];

    const result = {
        status: true,
        reasons: []
    };

    validationMap.forEach(validationItem => {
       if (validationItem.condition) {
           result.status = false;
           result.reasons.push(validationItem.code);
       }
    });

    return result;
}
